// Resources whose rows open a Show view, so Edit is reached through it.
const RESOURCES_WITH_SHOW = ['projects', 'routes'];

const listCrumb = (resource, t) => ({ label: t(`customMenu:${resource}`), to: `/${resource}` });

/**
 * Breadcrumb trail for a backoffice path. The list crumb is a plain `/<resource>` link:
 * react-admin restores the list's last filter/sort/page from its store when the URL has
 * no query, so it reopens the list as the user left it. Returns [] for list screens.
 */
export function getCrumbs(pathname, { t, recordLabel }) {
  const [resource, rawId, action] = pathname.split('/').filter(Boolean);
  if (!resource || !rawId) return [];

  if (resource === 'etapas' && rawId === 'weights') {
    return [listCrumb('etapas', t), { label: 'Pesos' }];
  }

  const id = decodeURIComponent(rawId);

  if (resource === 'project-tracking') {
    return [
      listCrumb('projects', t),
      { label: recordLabel('projects', id) || id, to: `/projects/${rawId}/show` },
      { label: 'Seguimiento' }
    ];
  }

  if (rawId === 'create') return [listCrumb(resource, t), { label: 'Nuevo' }];

  const record = { label: recordLabel(resource, id) || id };
  if (action === 'show') return [listCrumb(resource, t), record];

  if (RESOURCES_WITH_SHOW.includes(resource)) record.to = `/${resource}/${rawId}/show`;
  return [listCrumb(resource, t), record, { label: 'Editar' }];
}
